/**
 * Shared "swipe" cursor for desktop carousels.
 * Opt in by adding the data-swipe-cursor attribute to a <slideshow-component>.
 */
(() => {
  if (window.__swipeCursorInit) return;
  window.__swipeCursorInit = true;

  const DESKTOP_QUERY = window.matchMedia('(min-width: 1025px) and (hover: hover)');
  const IGNORE_SELECTOR = 'button, [role="button"], input, select, textarea, slideshow-arrows, slideshow-controls';

  let cursor = null;
  let activeSlideshow = null;
  let isDragging = false;
  let hasPosition = false;
  let frame = null;
  let currentX = 0;
  let currentY = 0;
  let targetX = 0;
  let targetY = 0;

  function getCursor() {
    if (cursor) return cursor;
    cursor = document.createElement('div');
    cursor.className = 'swipe-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.appendChild(document.createElement('span'));
    document.body.appendChild(cursor);
    return cursor;
  }

  function isSwipeable(slideshow) {
    if (slideshow.hasAttribute('fade') || slideshow.getAttribute('disabled') === 'true') return false;
    const scroller = slideshow.querySelector('slideshow-slides');
    return !!scroller && scroller.scrollWidth > scroller.clientWidth + 1;
  }

  function setActive(slideshow) {
    if (activeSlideshow === slideshow) return;
    activeSlideshow?.classList.remove('has-swipe-cursor');
    activeSlideshow = slideshow;
    activeSlideshow?.classList.add('has-swipe-cursor');
  }

  function hide() {
    cursor?.classList.remove('is-visible');
    setActive(null);
  }

  function render() {
    cursor.style.left = `${currentX}px`;
    cursor.style.top = `${currentY}px`;
  }

  function animate() {
    currentX += (targetX - currentX) * 0.18;
    currentY += (targetY - currentY) * 0.18;
    render();

    if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
      frame = requestAnimationFrame(animate);
    } else {
      currentX = targetX;
      currentY = targetY;
      render();
      frame = null;
    }
  }

  document.addEventListener('mousemove', (event) => {
    if (!DESKTOP_QUERY.matches || isDragging || !(event.target instanceof Element)) return;

    const slideshow = event.target.closest('slideshow-component[data-swipe-cursor]');
    const overSlide = slideshow && event.target.closest('slideshow-slides');

    if (!slideshow || !overSlide || event.target.closest(IGNORE_SELECTOR) || !isSwipeable(slideshow)) {
      hide();
      return;
    }

    const el = getCursor();
    el.firstChild.textContent = slideshow.getAttribute('data-swipe-cursor') || 'swipe';

    targetX = event.clientX;
    targetY = event.clientY;

    if (!hasPosition) {
      currentX = targetX;
      currentY = targetY;
      hasPosition = true;
      render();
    } else if (!frame) {
      frame = requestAnimationFrame(animate);
    }

    setActive(slideshow);
    el.classList.remove('is-disabled');
    el.classList.add('is-visible');
  });

  document.addEventListener('mouseleave', hide);

  document.addEventListener('pointerdown', (event) => {
    if (!activeSlideshow || (event.pointerType === 'mouse' && event.button !== 0)) return;
    isDragging = true;
    cursor?.classList.add('is-disabled');
  });

  const endDrag = () => {
    if (!isDragging) return;
    isDragging = false;
    cursor?.classList.remove('is-disabled');
  };

  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);
})();
